import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    boxContainer: {
            paddingTop: '35%',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
    },
    firstAvater: {
        backgroundColor: '#DC004E',
        marginBottom: 10
    },
    formBox: {
        marginTop: 20,
        width: '100%'
    },
    signIn: {
         marginTop: 30,
    },
    containerImage: {
        width: '100vw',
        height: '100vh',
    },

  }));
  export default useStyles;